export default "__VITE_ASSET__CsdcQwVD__ 480w, __VITE_ASSET__Bm4hCD6___ 768w, __VITE_ASSET__D_sc6w8i__ 1024w, __VITE_ASSET__DqLrBQkB__ 1125w";